import { Opportunity } from '@fullstory/proto/fs/services/alexa';
import { isNonNull } from '@fullstory/typeutils';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { eventsToSpecAnalytics } from '../specUtils';
import { trackGenerateOpportunitiesDisplayed } from './trackers';
import { AnalysisOrigin } from './types';
import { transformOpportunitiesDisplayed } from './util';
import { allSpecObjectsBySlug } from '@fullstory/redux';

// Helper to give a callback to call the FS custom event `trackGenerateOpportunitiesDisplayed` with all of the correct parameters.
export const useOpportunitiesDisplayedAnalytics = () => {
  const specObjectsBySlug = useSelector(allSpecObjectsBySlug);
  return useCallback(
    (
      opportunities: Opportunity[],
      mutedOpportunities: Opportunity[],
      requestId: string,
      origin: AnalysisOrigin,
      customSignalConfigured: boolean,
    ) => {
      trackGenerateOpportunitiesDisplayed({
        ...eventsToSpecAnalytics(
          opportunities.map(d => d.signal?.event).filter(isNonNull),
          specObjectsBySlug,
        ),
        ...transformOpportunitiesDisplayed(
          opportunities,
          mutedOpportunities,
          requestId,
          origin,
          customSignalConfigured,
        ),
      });
    },
    [specObjectsBySlug],
  );
};
